import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Home, BookOpen, Calendar, Heart, MessageCircle, LogOut, Menu, X } from 'lucide-react';
import './Navbar.css';

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/dashboard" className="navbar-brand" onClick={closeMobileMenu}>
          <BookOpen size={28} />
          <span>HolyBible365</span>
        </Link>

        <button className="mobile-menu-toggle" onClick={toggleMobileMenu}>
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        <div className={`navbar-menu ${mobileMenuOpen ? 'active' : ''}`}>
          <Link 
            to="/dashboard" 
            className={`navbar-link ${location.pathname === '/dashboard' ? 'active' : ''}`} 
            onClick={closeMobileMenu}
          >
            <Home size={20} />
            <span>Home</span>
          </Link>
          <Link 
            to="/today" 
            className={`navbar-link ${location.pathname === '/today' ? 'active' : ''}`} 
            onClick={closeMobileMenu}
          >
            <BookOpen size={20} />
            <span>Today's Reading</span>
          </Link>
          <Link 
            to="/plan" 
            className={`navbar-link ${location.pathname === '/plan' ? 'active' : ''}`} 
            onClick={closeMobileMenu}
          >
            <Calendar size={20} />
            <span>Full Plan (365)</span>
          </Link>
          <Link 
            to="/motivation" 
            className={`navbar-link ${location.pathname === '/motivation' ? 'active' : ''}`} 
            onClick={closeMobileMenu}
          >
            <Heart size={20} />
            <span>Motivation</span>
          </Link>
          <Link 
            to="/prayer" 
            className={`navbar-link ${location.pathname === '/prayer' ? 'active' : ''}`} 
            onClick={closeMobileMenu}
          >
            <MessageCircle size={20} />
            <span>Prayer Request</span>
          </Link>
          <button onClick={handleLogout} className="navbar-link logout-btn">
            <LogOut size={20} />
            <span>Logout</span>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
